export const BUSINESS = {
  name: "KAJ Contracting",
  phone: "0488 640 334",
  email: "jwest7398@gmail.com",
  area: "NSW",
};

export const SERVICES = [
  {
    id: "windmill-repairs",
    name: "Windmill Repairs",
    icon: "Wind",
    blurb:
      "Mechanical windmill servicing, rebuilds and breakdown call-outs to keep your water pumping.",
    price: "From $110/hr",
  },
  {
    id: "irrigation-repairs",
    name: "Irrigation Repairs",
    icon: "Droplets",
    blurb:
      "Leaks, valves, controllers and lines found and fixed fast, so not a drop is wasted.",
    price: "From $110/hr",
  },
  {
    id: "irrigation-plumbing",
    name: "Irrigation Plumbing",
    icon: "Wrench",
    blurb:
      "New pipework, mains and risers laid out properly for stock, pasture and garden.",
    price: "From $110/hr",
  },
  {
    id: "tank-installation",
    name: "Tank Installation",
    icon: "Container",
    blurb:
      "Supply and install of water tanks, pads, plumbing and overflow — sized to your place.",
    price: "From $110/hr",
  },
  {
    id: "filter-installation",
    name: "Filter Installation",
    icon: "Filter",
    blurb:
      "Bore, dam and house water filtration set up right for clean, reliable water.",
    price: "From $110/hr",
  },
  {
    id: "fencing",
    name: "Fencing",
    icon: "Fence",
    blurb:
      "Stock, boundary and yard fencing built straight, strained tight and made to last.",
    price: "From $25 per metre",
  },
  {
    id: "bore-cleaning",
    name: "Bore Cleaning",
    icon: "Waves",
    blurb:
      "Bore flushing and cleaning to restore flow and water quality without the guesswork.",
    price: "From $2,000",
  },
];

export const PILLARS = [
  {
    icon: "FileText",
    title: "Free Written Quotes",
    text: "Fair, transparent pricing. You get it in writing before any work starts — no surprises.",
  },
  {
    icon: "Clock",
    title: "Fast Turnaround",
    text: "We show up when we say we will and get the job done without dragging it out.",
  },
  {
    icon: "ShieldCheck",
    title: "Licensed & Insured",
    text: "Fully licensed and insured, with guarantees on the work we stand behind.",
  },
  {
    icon: "BadgeCheck",
    title: "Quality Craftsmanship",
    text: "We treat every job like it's our own home — done right, first time.",
  },
];

export const IMAGES = {
  hero: "https://images.pexels.com/photos/13608870/pexels-photo-13608870.jpeg?auto=compress&cs=tinysrgb&w=1920",
  irrigation:
    "https://images.unsplash.com/photo-1743742566156-f1745850281a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwzfHxhZ3JpY3VsdHVyZSUyMGlycmlnYXRpb258ZW58MHx8fHwxNzkyMzY5MjkxfDA&ixlib=rb-4.1.0&q=85",
  contractor:
    "https://images.pexels.com/photos/8487340/pexels-photo-8487340.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};
